import { Modal } from '@roo/roo';
import React, { ComponentProps, FC, useEffect, useRef, useState } from 'react';

import { failToast } from '@utils/toast';
import doLogout from '@shell/utils/doLogout';

import styles from './StrongAlertModal.module.scss';

type StrongAlertModalModalProps = Partial<Pick<ComponentProps<typeof Modal>, 'visible'>>;

/** 弹窗dom检测时间间隔 */
const CheckIntervalTime = 1;
/** 最大dom检测不到次数 */
const MaxNoPassCount = 3;

/**
 * 强提示弹窗
 */
const StrongAlertModal: FC<StrongAlertModalModalProps> = ({ visible = false }) => {
    const domRef = useRef<HTMLDivElement>(null);
    const [noPassCount, setNoPassCount] = useState<number>(0);

    useEffect(() => {
        let timer: NodeJS.Timeout | null = null;

        if (visible) {
            timer = setInterval(() => {
                const { current: dom } = domRef;
                const { width, height } = dom?.getBoundingClientRect() ?? { width: 0, height: 0 };
                if (width < 1 || height < 1) {
                    setNoPassCount(prev => prev + 1);
                }
            }, CheckIntervalTime * 1000);
        }

        return () => {
            if (timer) {
                clearInterval(timer);
                timer = null;
            }
        };
    }, [visible]);

    useEffect(() => {
        if (noPassCount > MaxNoPassCount - 1 && visible) {
            failToast('系统检测到升级提醒展示异常，已自动登出。', 5 * 1000);
            setTimeout(() => {
                doLogout();
            }, 5 * 1000);
        }
    }, [noPassCount, visible]);

    return (
        <Modal
            closable={false}
            visible={visible}
            key={noPassCount}
            title="客户端停止使用说明"
            showCancelButton={false}
            showConfirmButton={false}
        >
            <div className={styles.main} ref={domRef}>
                <p>
                    当前软件已停止使用，为保证您的正常经营，请使用&nbsp;Win7&nbsp;或以上版本系统，下载&nbsp;5.0.1&nbsp;以上版本商家端登录使用&nbsp;
                    <a href="https://waimaie.meituan.com/gw/version/pc/download">
                        https://waimaie.meituan.com/gw/version/pc/download
                    </a>
                    ，否则因此产生的任何责任需要商家关注并自行承担。
                </p>
            </div>
        </Modal>
    );
};

export default StrongAlertModal;
export { StrongAlertModal };
